const CategoryTree = require('components/category_select/category_tree');
const ElectricGuitarsPhotoContents = require('./contents/electric_guitars.js');
const BassGuitarsPhotoContents = require('./contents/bass_guitars.js');
const AcousticGuitarsPhotoContents = require('./contents/acoustic_guitars.js');

const productTypeCheckers = {
  [ElectricGuitarsPhotoContents.productTypeUUID]: ElectricGuitarsPhotoContents,
  [BassGuitarsPhotoContents.productTypeUUID]: BassGuitarsPhotoContents,
  [AcousticGuitarsPhotoContents.productTypeUUID]: AcousticGuitarsPhotoContents,
};

module.exports = class CheckPhotoContents {
  constructor(categories, imageDetectionPath) {
    this.categoryTree = new CategoryTree(categories);
    this.imageDetectionPath = imageDetectionPath;
  }

  checkContents({ categoryId, condition, photo }) {
    if (!photo) { return Promise.resolve([{ showWarning: false }]); }
    const productTypeUUID = categoryId &&
      this.categoryTree.findById(categoryId).root.uuid;

    const checkers = this.getApplicableCheckers(productTypeUUID, condition);
    if (checkers.length === 0) { return Promise.resolve([{ showWarning: false }]); }
    const checks = checkers.map(Checker =>
      new Checker(photo, this.imageDetectionPath).checkPhoto());
    return Promise.all(checks);
  }

  getApplicableCheckers(productTypeUUID, condition) {
    const checkers = [];
    const productTypeChecker = productTypeCheckers[productTypeUUID];
    if (productTypeChecker) {
      checkers.push(productTypeChecker);
    }
    return checkers;
  }
};



// WEBPACK FOOTER //
// ./javascripts/components/photos/check_photo_contents.js